import { render, staticRenderFns } from "./tabProductAttributes.vue?vue&type=template&id=798ac1bd&"
import script from "./tabProductAttributes.vue?vue&type=script&lang=js&"
export * from "./tabProductAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports